import { httpClient } from '../lib/http-client';
import { Configuracao } from '../types';

/**
 * Service para gerenciamento de configurações
 */
export class ConfiguracoesService {
  static async getConfiguracoes(): Promise<Configuracao[]> {
    return httpClient.get<Configuracao[]>('/api/configuracoes');
  }

  static async getConfiguracao(id: number): Promise<Configuracao> {
    return httpClient.get<Configuracao>(`/api/configuracoes/${id}`);
  }

  static async getConfiguracaoPorNome(nome: string): Promise<Configuracao> {
    return httpClient.get<Configuracao>(`/api/configuracoes/nome/${nome}`);
  }

  static async createConfiguracao(data: Partial<Configuracao>): Promise<Configuracao> {
    return httpClient.post<Configuracao>('/api/configuracoes', data);
  }

  static async updateConfiguracao(id: number, data: Partial<Configuracao>): Promise<Configuracao> {
    return httpClient.put<Configuracao>(`/api/configuracoes/${id}`, data);
  }

  static async updateConfiguracaoPorNome(
    nome: string,
    data: { valor: string }
  ): Promise<Configuracao> {
    return httpClient.put<Configuracao>(`/api/configuracoes/nome/${nome}`, data);
  }

  static async deleteConfiguracao(id: number): Promise<{ success: boolean }> {
    return httpClient.delete<{ success: boolean }>(`/api/configuracoes/${id}`);
  }

  static async inicializarConfiguracoesPadrao(): Promise<{
    success: boolean;
    message: string;
    criadas: number;
  }> {
    return httpClient.post<{ success: boolean; message: string; criadas: number }>(
      '/api/configuracoes/inicializar-padrao'
    );
  }
}

